import styled from "styled-components"

export const DeprecatedHeader = styled.header.attrs<{
  $colors?: "default" | "info" | "warning" | "danger"
  $fixedHeight?: boolean
}>(({ $colors, theme }) => ({
  $colors: $colors ?? theme.header.defaultColors,
}))`
  min-height: 8.375rem;
  ${({ $fixedHeight }) => ($fixedHeight ? "height: 8.375rem" : "unset")};
  padding-right: 3rem;
  padding-left: 3rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.separator.bottom};

  &:before {
    display: block;
    content: "";
    margin-bottom: 2.5rem;
  }
`
